import { Link } from "react-router-dom";
import { Users, ArrowUpRight, ImageOff } from "lucide-react";
import { fotoUrl } from "@/lib/publicApi";
import { brl } from "@/lib/api";
import { labelComodidadeQuarto } from "@/lib/comodidades";

// Card de quarto exibido na página da pousada.
export function QuartoCard({ quarto, testid }) {
  if (!quarto) return null;
  const foto = quarto.foto_principal_id ? fotoUrl(quarto.foto_principal_id) : null;
  const comodidades = Array.isArray(quarto.comodidades) ? quarto.comodidades.slice(0, 3) : [];
  const tipoLabel = labelTipoQuarto(quarto.tipo);

  return (
    <Link
      to={`/quartos/${quarto.id}`}
      data-testid={testid || `quarto-card-${quarto.id}`}
      className="group flex flex-col sm:flex-row bg-[#FFFFFF] border border-stone-200 rounded-lg overflow-hidden transition-all hover:border-[#083A6B]/40 hover:shadow-[0_8px_24px_-12px_rgba(44,76,59,0.2)]"
    >
      <div className="relative sm:w-56 aspect-[4/3] sm:aspect-auto bg-stone-100 flex-shrink-0 overflow-hidden">
        {foto ? (
          <img
            src={foto}
            alt={quarto.numero}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-stone-300">
            <ImageOff size={28} strokeWidth={1.3} />
          </div>
        )}
      </div>

      <div className="flex-1 p-5 flex flex-col gap-3">
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-[#D4A652] font-semibold">
            {tipoLabel}
          </div>
          <h4 className="font-public-title text-xl text-stone-900 leading-tight mt-1">
            {quarto.numero}
          </h4>
          <div className="flex items-center gap-1.5 text-xs text-stone-500 mt-2">
            <Users size={12} />
            <span>Até {quarto.capacidade} {quarto.capacidade === 1 ? "hóspede" : "hóspedes"}</span>
          </div>
        </div>

        {quarto.descricao && (
          <p className="text-sm text-stone-600 leading-relaxed line-clamp-2">
            {quarto.descricao}
          </p>
        )}

        {comodidades.length > 0 && (
          <div className="flex flex-wrap gap-1.5">
            {comodidades.map((c) => (
              <span key={c} className="text-[11px] px-2 py-0.5 rounded-full bg-stone-100 text-stone-600">
                {labelComodidadeQuarto(c)}
              </span>
            ))}
          </div>
        )}

        <div className="mt-auto pt-3 flex items-end justify-between border-t border-stone-200/70">
          <div>
            {quarto.valor_diaria != null && quarto.valor_diaria > 0 ? (
              <>
                <div className="text-[10px] uppercase tracking-[0.2em] text-stone-500">A partir de</div>
                <div className="font-public-title text-lg text-[#083A6B]">{brl(quarto.valor_diaria)}<span className="text-xs text-stone-500 font-sans"> / diária</span></div>
              </>
            ) : (
              <div className="text-xs text-stone-500">Consulte valores</div>
            )}
          </div>
          <span className="inline-flex items-center gap-1 text-[12px] font-medium text-[#083A6B] group-hover:gap-2 transition-all">
            Ver quarto <ArrowUpRight size={14} />
          </span>
        </div>
      </div>
    </Link>
  );
}

export function labelTipoQuarto(tipo) {
  const map = {
    standard: "Standard",
    luxo: "Luxo",
    suite: "Suíte",
    master: "Master",
    familia: "Família",
    casal: "Casal",
    solteiro: "Solteiro",
    chale: "Chalé",
    chacara_inteira: "Chácara inteira",
    pousada_inteira: "Pousada inteira",
  };
  return map[tipo] || (tipo ? tipo.charAt(0).toUpperCase() + tipo.slice(1) : "Quarto");
}
